import { JsonPipe, CommonModule, DecimalPipe, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet, RouterModule, Router } from '@angular/router';
import { NgbNavModule, NgbDatepickerModule, NgbAlertModule, NgbTimepickerModule, NgbDropdownModule, NgbTooltip, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CompensatoryOffService } from '../../../Model/CompensatoryOff/compensatory-off.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CompensatoryOffConsumeFormPopupComponent } from '../compensatory-off-consume-form-popup/compensatory-off-consume-form-popup.component';
import moment from 'moment';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-compensatory-off-consume-form',
  standalone: true,
  imports: [NgbNavModule, NgbDatepickerModule, FormsModule, JsonPipe, NgbAlertModule, NgbTimepickerModule, CommonModule, DecimalPipe, AsyncPipe, DataTablesModule, ReactiveFormsModule, AsyncPipe, NgbDropdownModule, RouterOutlet, RouterModule, NgbTooltip, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './compensatory-off-consume-form.component.html',
  styleUrl: './compensatory-off-consume-form.component.scss'
})
export class CompensatoryOffConsumeFormComponent {
  isDisabled: boolean = false;

  HalfDaySessions = [{ Name: 'First Half', Value: 'First Half' }, { Name: 'Second Half', Value: 'Second Half' }]
  CompensatoryConsume = {
    SelectType: 'I',
    ESS_EmployeeCompOffConsumeId: 0,
    ESS_EmployeeCompOffRaiseId: 0,
    EmpMasterID: null,
    LeaveFromDate: null as any,
    LeaveFromDateObj: null as any,
    LeaveToDate: null as any,
    LeaveToDateObj: null as any,
    HalfDay: false,
    HalfDaySession: null,
    Reason: null,
    TotalCount: 0,
    NoOfDay: 0,
    BalanceCount: 0
  };

  constructor(
    private session: SessionService,
    public common: CommonService,
    public toast: ToastService,
    public dateFormate: CustomDateParserFormatter,
    private router: Router,
    protected tooltip: TooltipService,
    private modalService: NgbModal,
    private compensatoryOff: CompensatoryOffService,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.CompensatoryConsume.EmpMasterID = this.session.GetUserDetails().UserId;
    //this.SelectDate('RegistrationDate', null, null);
    this.ESS_EmployeeCompOffConsumeLoad()
  }

  Validate(form: any) {
    if (this.CompensatoryConsume.NoOfDay < 0) {
      this.toast.show({ message: 'To Date must be greater than From Date!', type: toastTypeEnum.warning });
      return
    }
    else if(this.CompensatoryConsume.NoOfDay > this.CompensatoryConsume.BalanceCount){
      this.toast.show({ message: 'No of days cannot be greater than balance count!', type: toastTypeEnum.warning });
      return
    }
    if (form.valid) {
      this.EmployeeCompOffConsumeSave();
    }
    else {
      form.submitted = true;
    }
  }

  Openpopup(SelectTye: number) {
    if (this.CompensatoryConsume.LeaveFromDateObj == null || this.CompensatoryConsume.LeaveFromDateObj == '' ||
      this.CompensatoryConsume.LeaveToDateObj == null || this.CompensatoryConsume.LeaveToDateObj == ''
    ) {
      this.toast.show({ message: "Please Select from date and to date", type: toastTypeEnum.warning });
    } else if (moment(this.dateFormat.format(this.CompensatoryConsume.LeaveFromDateObj)).isAfter(moment(this.dateFormat.format(this.CompensatoryConsume.LeaveToDateObj)))) {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    } else {
      // if (SelectTye == 1) {
      //   this.ESS_EmployeeCompOffConsumeLoad();
      // } else
      if (SelectTye == 2) {
        const modalRef = this.modalService.open(CompensatoryOffConsumeFormPopupComponent, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.LeaveFromDate = this.dateFormate.format(this.CompensatoryConsume.LeaveFromDateObj);
        modalRef.componentInstance.LeaveToDate = this.dateFormate.format(this.CompensatoryConsume.LeaveToDateObj);
        modalRef.componentInstance.EmpMasterID = this.CompensatoryConsume.EmpMasterID;
        modalRef.result.then(result => { });
      }
    }
  }

  ESS_EmployeeCompOffConsumeLoad() {
    this.isDisabled = true;
    this.compensatoryOff.ESS_EmployeeCompOffConsumeLoad({ 'SelectType': 1, 'EmpMasterID': this.CompensatoryConsume.EmpMasterID, 'FromDate': null, 'ToDate': null, }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.CompensatoryConsume.TotalCount = response.Table[0].TotalBalance;
        } else {
          this.CompensatoryConsume.TotalCount = 0;
        }
        console.log(response);
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  EmployeeCompOffConsumeSave() {
    if (this.CompensatoryConsume.TotalCount >= 0 && this.CompensatoryConsume.TotalCount >= this.CompensatoryConsume.NoOfDay) {

      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if (result) {
          this.isDisabled = true;
          this.CompensatoryConsume.LeaveFromDate = this.dateFormate.format(this.CompensatoryConsume.LeaveFromDateObj);
          this.CompensatoryConsume.LeaveToDate = this.dateFormate.format(this.CompensatoryConsume.LeaveToDateObj);
          this.compensatoryOff.EmployeeCompOffConsumeSave(this.CompensatoryConsume).subscribe({
            next: (response) => {
              if (response.Error_Code == "411") {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.close();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    } else {
      this.toast.show({ message: "Available " + this.CompensatoryConsume.TotalCount + " compensatory off for consume", type: toastTypeEnum.warning });
    }
  }

  Clear() {
    this.CompensatoryConsume.BalanceCount = 0;
    this.CompensatoryConsume.NoOfDay = 0;
    this.isDisabled = true;
    this.compensatoryOff.ESS_EmployeeCompOffConsumeLoad({ 'SelectType': 5, 'EmpMasterID': this.CompensatoryConsume.EmpMasterID, 'FromDate': this.dateFormate.format(this.CompensatoryConsume.LeaveFromDateObj), 'ToDate': this.dateFormate.format(this.CompensatoryConsume.LeaveToDateObj), }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.CompensatoryConsume.BalanceCount = response.Table[0].TotalBalance;
        } else {
          this.CompensatoryConsume.BalanceCount = 0;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.router.navigate(['/request/compensatoryoffconsume/']);
  }

  NoOfDayCount() {
    if (this.CompensatoryConsume.LeaveFromDateObj != null && this.CompensatoryConsume.LeaveToDateObj != null) {
      this.CompensatoryConsume.NoOfDay = (Math.floor((Date.UTC(this.CompensatoryConsume.LeaveToDateObj.year, this.CompensatoryConsume.LeaveToDateObj.month, this.CompensatoryConsume.LeaveToDateObj.day) - Date.UTC(this.CompensatoryConsume.LeaveFromDateObj.year, this.CompensatoryConsume.LeaveFromDateObj.month, this.CompensatoryConsume.LeaveFromDateObj.day)) / (1000 * 60 * 60 * 24)) + 1) / (this.CompensatoryConsume.HalfDay ? 2 : 1);
    } else if (this.CompensatoryConsume.LeaveFromDateObj != null) {
      this.CompensatoryConsume.NoOfDay = 1 / (this.CompensatoryConsume.HalfDay ? 2 : 1);
    } else {
      this.CompensatoryConsume.NoOfDay = 0;
    }
    if (this.CompensatoryConsume.NoOfDay < 0) {
      this.toast.show({ message: 'To Date must be greater than From Date!', type: toastTypeEnum.warning });
      return
    }
  }
  CardCountFilter() {
    const modalRef = this.modalService.open(CompensatoryOffConsumeFormPopupComponent, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.LeaveFromDate = '';//this.dateFormate.format(this.CompensatoryConsume.LeaveFromDateObj);
    modalRef.componentInstance.LeaveToDate = '';//this.dateFormate.format(this.CompensatoryConsume.LeaveToDateObj);
    modalRef.componentInstance.EmpMasterID = this.CompensatoryConsume.EmpMasterID;
    modalRef.result.then(result => { });
  }
}
